import { ObjectId } from 'bson';

export default class MongoProjectPledge {
  static TYPE_HEARTS = "hearts";
  static TYPE_CENTS = "cents";
  static TYPE_CASH = "cash";
  static TYPE_PERCENT = "Percent";

  static FIREDBY_MANALLY = "manually";
  static FIREDBY_AUTO = "monthly";

  static MONTHLY_AMOUNT = "Amount";
  static MONTHLY_PERCENT = "Percent";

  _id = null;
  docId = "";

  projectId = "";
  projectTitle = "";
  projectMedia = null;                                    // MondoMedia
  projectCategory = "";

  creatorId = "";
  creatorName = "";
  creatorLogoUrl = "";

  pledgerId = "";
  pledgerName = "";
  pledgerLogoUrl = "";

  type = MongoProjectPledge.TYPE_HEARTS;
  amount = 0;
  percentAmount = 0;
  currencyCode = "GBP";

  firedBy = MongoProjectPledge.FIREDBY_MANALLY;

  timestamp = 0;

  constructor() {
    this._id = new ObjectId();
    this.docId = this._id.valueOf().toString();
    this.timestamp = new Date();
  }
}
